import React, { createContext, useContext, useState } from 'react';

const LoadingContext = createContext();

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};

export const LoadingProvider = ({ children }) => {
  const [loadingStates, setLoadingStates] = useState({
    uploadingImages: false,
    uploadingDocuments: false,
    uploadingVideos: false,
    uploadingFloorPlans: false,
    uploadingStagedImages: false,
    submitting: false,
    loadingProperty: false,
    loadingStatus: false,
    loadingFav: false
  });

  const startLoading = (type) => {
    setLoadingStates((prev) => ({
      ...prev,
      [type]: true
    }));
  };

  const stopLoading = (type) => {
    setLoadingStates((prev) => ({
      ...prev,
      [type]: false
    }));
  };

  const refreshFavIcon = () => {
    setLoadingStates((prev) => ({
      ...prev,
      ['loadingFav']: !loadingStates.loadingFav
    }));
  };

  const isAnythingLoading = () => {
    return Object.values(loadingStates).some((state) => state === true);
  };

  const value = {
    loadingStates,
    startLoading,
    stopLoading,
    isAnythingLoading,
    refreshFavIcon
  };

  return <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>;
};
